const ANALYTICS = {
  PLAY: 'play',
  PLAY_BTN: 'play-btn'
}

export default ANALYTICS
